import Home from "../home/containers/index";
import AssetListing from "../home/containers/assets";
import pageLayoutHoc from "../../hocs/pageLayoutHoc";
import userRoleBaseAccessHoc from "../../hocs/userRoleBaseAccessHoc";
import Profile from "../home/containers/profile";
import ApplicationsAccess from "./containers/ApplicationsAccess";
import FleetMainAd from "../fleet/containers/FleetMainAd";
import FleetMainSB from "../fleet/containers/FleetMainSB";
import Configure from "../fleet/containers/Configure";
import Inventory from "../fleet/containers/Inventory";
import FAQs from "./containers/FAQs";
import WhatsNew from "./containers/WhatsNew";
import Notifications from "./containers/Notifications";
import LlpTemplate from "../fleet/containers/LlpTemplate";
import Templates from "../templates/pages/index.js";
import UtilizationApproval from "../fleet/containers/UtilizationApproval.js";
import EngineModule from "../templates/pages/EngineModule.js";
export const assetRoutes = [
	{
		path: "/",
		component: pageLayoutHoc(userRoleBaseAccessHoc(AssetListing, ['asset_management','R']), { apps: "AssetListing", layoutPhase: 1 }),
		key: "MntAssetList",
	},
	{
		path: "/apps-switcher",
		component: pageLayoutHoc(userRoleBaseAccessHoc(ApplicationsAccess, ['asset_management','R']), { apps: "Switcher", layoutPhase: 1 }),
		key: "MntAssetList",
	},
	{
		path: "/home",
		component: pageLayoutHoc(userRoleBaseAccessHoc(Home, ['asset_management','R']), { apps: "Assets", layoutPhase: 1, }),
		key: "MntAssetList",
	},
	{
		path: "/assets-listing",
		component: pageLayoutHoc(userRoleBaseAccessHoc(AssetListing, ['asset_management','R']), { apps: "AssetListing", layoutPhase: 1 }),
		key: "MntAssetList",
	},
	{
		path: "/fleet/ad",
		component: pageLayoutHoc(userRoleBaseAccessHoc(FleetMainAd, ['asset_management','R']), { apps: "AD", layoutPhase: 1 }),
		key: "AD",
	},
	{
		path: "/fleet/sb",
		component: pageLayoutHoc(userRoleBaseAccessHoc(FleetMainSB, ['asset_management','R']), { apps: "SB", layoutPhase: 1 }),
		key: "SB",
	},
	{
		path: "/configure/disclaimer",
		component: pageLayoutHoc(userRoleBaseAccessHoc(Configure, ['asset_management','R']), { apps: "Configure", layoutPhase: 1 }),
		key: "Configure",
	},
	{
		path: "/camo/consignment",
		component: pageLayoutHoc(userRoleBaseAccessHoc(Inventory, ['asset_management','R']), { apps: "inventory", layoutPhase: 1 }),
		key: "Inventory",
	},
	{
		path: "/profile",
		component: pageLayoutHoc(userRoleBaseAccessHoc(Profile, ['asset_management','R']), { apps: "Profile", layoutPhase: 1 }),
		key: "MntAssetList",
	},
	{
		path: '/faqs',
		component: pageLayoutHoc(userRoleBaseAccessHoc(FAQs,['asset_management','R']), { apps: "FAQs", layoutPhase: 3 }),
		key: 'FAQs'
	},
	{
		path: '/whats-new',
		component: pageLayoutHoc(userRoleBaseAccessHoc(WhatsNew,['asset_management','R']), { apps: "what's", layoutPhase: 3 }),
		key: 'whats'
	},
	{
		path: '/notifications',
		component: pageLayoutHoc(userRoleBaseAccessHoc(Notifications,['asset_management','R']), { apps: "notifications", layoutPhase: 3 }),
		key: 'Notifications'
	},
	{
		path: "/configure/llp",
		component: pageLayoutHoc(userRoleBaseAccessHoc(LlpTemplate,['asset_management','R']), { apps: "Configure", layoutPhase: 1 }),
		key: "llp",
	},
	{
		path: "/configure/engine",
		component: pageLayoutHoc(userRoleBaseAccessHoc(EngineModule, ['asset_management','R']), { apps: "Engine Module", layoutPhase: 1 }),
		key: "engine",
	},
		{
		path: "/camo/templates",
		component: pageLayoutHoc(userRoleBaseAccessHoc(Templates,['asset_management','R']), { apps: "templates", layoutPhase: 1 }),
		key: "templates" 
	},
	{
		path: "/configure/utilization-approval",
		component: pageLayoutHoc(userRoleBaseAccessHoc(UtilizationApproval, ['asset_management','R']), { apps: "utilization-approval", layoutPhase: 1 }),
		key: "utilization-approval"
	},


];

